var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94778 6.00008H5.72778C6.83445 6.00008 7.28445 5.21675 6.73445 4.26008L6.48778 3.83341C6.42778 3.73008 6.31778 3.66675 6.19778 3.66675L3.47778 3.66675C3.35778 3.66675 3.24778 3.73008 3.18778 3.83341L2.94112 4.26008C2.39112 5.21675 2.84112 6.00008 3.94778 6.00008Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.76791 3.33343H5.91124C6.04124 3.33343 6.12124 3.19343 6.05458 3.08343L5.84124 2.71677C5.29124 1.7601 4.38458 1.7601 3.83458 2.71677L3.62124 3.08343C3.55791 3.19343 3.63791 3.33343 3.76791 3.33343Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.bc63809dd26edea8b517324620446fe7.svg";
export { ForwardRef as ReactComponent };